import { render, staticRenderFns } from "./SpecialRecommend.vue?vue&type=template&id=473543c4&"
import script from "./SpecialRecommend.vue?vue&type=script&lang=js&"
export * from "./SpecialRecommend.vue?vue&type=script&lang=js&"
import style0 from "./SpecialRecommend.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports